﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const __1 = require("../../");
class AuthorizedComponentInternal extends React.Component {
    render() {
        if (this.props.hasPermission) {
            return (this.props.component);
        }
        else {
            return (null);
        }
    }
}
function mapStateToProps(state, props) {
    return { hasPermission: __1.SessionSelector.hasPermissions(props.requiredPermissions)(state) };
}
exports.AuthorizedComponent = react_redux_1.connect(mapStateToProps)(AuthorizedComponentInternal);
//# sourceMappingURL=AuthorizedComponent.js.map